import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-cefloreco-banner-1.js';
const html = `
<div class="wrap-banner">
  <div
    data-use-custom-width="true"
    data-custom-width="1204"
    class="container"
    data-attribute="container-content"
    style="--custom-width: 1204px;"
  >
    <div class="title-banner" data-attribute="title-banner">
      <p>
      <span style="color:hsl(30, 75%, 60%);">Digital Product Studio</span>
      </p>
      <h2>Creativity <br> brought to life</h2>
      <p>We turn ideas into digital products, <br> stories and experiences used worldwide.</p>
    </div>
  </div>
  <div class="wrap-banner-image" data-attribute="wrap-banner-image" data-use-banner-mobile="true">
    <img
      class="banner-image-desktop"
      data-attribute="banner-image-desktop"
      src="https://cdn.skyfastimg.com/images/2026/10/26/image-6adf1aa4ec27dcd1d8019fe7.webp?w=1920"
      alt=""
    />
    <img
      class="banner-image-mobile"
      data-attribute="banner-image-mobile"
      src="https://cdn.skyfastimg.com/images/2026/10/26/image-6adf1ad73885cb4b9c841416.webp?w=768"
      alt=""
    />
  </div>
</div>
`;

export default containerFuild(html, css, {
  topPadding: false,
  bottomPadding: false,
});
